jQuery.fn.extend({

    /*
     * Adds Progressbar to any nearest [data-progressbar] container and
     *  .m-progressBar-indicator class element inside it shown as indicator
     */
    progressBar: function (currentValue, totalValue) {
        var progressBar = islington.findNearestElement(this, '[data-progressbar]'),
        division = currentValue / totalValue,
        percentage = division * 100;

        percentage = percentage + "%";
        progressBar.find('.m-progressBar-indicator').width(percentage);
    },

    /*
     * finds element has that attri attribute or not
    */
    hasAttr: function(attri){
    	return islington.checkValidity($(this).attr(attri));
    },

    /*
     * hides a container with disabled fields in to it.
     */
    hideWithDisabledFields: function () {
        var _self = $(this),
            fieldsInside = _self.find('input,select');

        _self.hide();
        fieldsInside.attr("disabled", "true");
    },

    /*
     * show a container with enabled fields in to it.
     */
    showWithEnabledFields: function () {
        var _self = $(this),
            fieldsInside = _self.find('input,select');

        _self.show();
        fieldsInside.prop("disabled", false);
    }

});
